import React, { useState } from 'react';
import { Search, CheckCircle, XCircle, Info } from 'lucide-react';

interface Certificate {
  certificateId: string;
  volunteerName: string;
  eventName: string;
  issueDate: string;
  certificateType: string;
  status: string;
}

const certificatesData: Certificate[] = [
  {
    "certificateId": "ADF-NGO-MEMBER000",
    "volunteerName": "Demo:Anbu Basha Peeter",
    "eventName": "Our Volunteer",
    "issueDate": "2025-06-01",
    "certificateType": "Certificate of Welcome",
    "status": "Expired"
  },
  {
    "certificateId": "ADF-NGO-EVENT000",
    "volunteerName": "Demo:Anbu Basha Peeter",
    "eventName": "Tree Plantation Program",
    "issueDate": "2025-06-03",
    "certificateType": "Certificate of Event Enrollment",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-NGO-RAFFI",
    "volunteerName": "Mr. Raffi A., President, Arrow Drop Foundation",
    "eventName": "Social Activism",
    "issueDate": "2025-05-28",
    "certificateType": "Certificate of Directorship",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-NGO-MUNVER",
    "volunteerName": "Mr. Munversheriff A., Secretary, Arrow Drop Foundation",
    "eventName": "Social Activism",
    "issueDate": "2025-05-28",
    "certificateType": "Certificate of Directorship",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-NGO-THAMARAI",
    "volunteerName": "Mr. Thamarai Selvam T., Treasurer, Arrow Drop Foundation",
    "eventName": "Social Activism",
    "issueDate": "2025-05-28",
    "certificateType": "Certificate of Treasurer Role",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-NGO-LEGAL",
    "volunteerName": "Mr. R. Noor Mohammed, B.A., LL.B., Legal Advisor, High Court of Madras, Chamber No. 298",
    "eventName": "Legal Advisory & Governance",
    "issueDate": "2025-05-28",
    "certificateType": "Certificate of Legal Advisory Appointment",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-NGO-MANVIL",
    "volunteerName": "Mr. A.V. Manvil, Member, Arrow Drop Foundation",
    "eventName": "Social Activism",
    "issueDate": "2025-06-05",
    "certificateType": "Certificate of Membership",
    "status": "Valid"
  },
   {
    "certificateId": "ADF-NGO-THANGAVEL",
    "volunteerName": "Mr. THANGAVEL PALANIYAPPAN, Member, Arrow Drop Foundation",
    "eventName": "Social Activism",
    "issueDate": "2025-06-06",
    "certificateType": "Certificate of Membership",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-NGO-KARTHIKEYAN",
    "volunteerName": "Mr. KARTHIKEYAN K Msc., S.S.,, Member, Arrow Drop Foundation",
    "eventName": "Social Activism",
    "issueDate": "2025-06-06",
    "certificateType": "Certificate of Membership",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-NGO-SULAIMAN",
    "volunteerName": "Mr. Sulaiman A, Member, Arrow Drop Foundation",
    "eventName": "Social Activism",
    "issueDate": "2025-06-14",
    "certificateType": "Certificate of Membership",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-NGO-000753610",
    "volunteerName": "Mr.Srinivasan. K,",
    "eventName": "Our Volunteer",
    "issueDate": "2025-05-29",
    "certificateType": "Certificate of Volunteer",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-NGO-000770681",
    "volunteerName": "Mr.Sasi Kumar. AJ,",
    "eventName": "Our Volunteer",
    "issueDate": "2025-05-29",
    "certificateType": "Certificate of Volunteer",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-NGO-000778116",
    "volunteerName": "Mr.Thamarai Kannan. M,",
    "eventName": "Our Volunteer",
    "issueDate": "2025-05-29",
    "certificateType": "Certificate of Volunteer",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-NGO-2-EVENT",
    "volunteerName": "Thangavel, Thamarai selvam, Karthik, Manvil AV, Raffi, Munver Sheriff",
    "eventName": "Vetri Vinayagar Temple Community Development",
    "issueDate": "2025-06-10",
    "certificateType": "Certificate of Sponsorship",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-NGO-3-EVENT",
    "volunteerName": "Mr. Raffi A., Mr. Munver Sheriff A., Mr. Karthikeyan K, and Mr. Sasikumar M",
    "eventName": "ADF-NGO-Event – Mushroom Cultivation Training successfully completed. Our team, consisting of Mr. Raffi A., Mr. Munver Sheriff A., Mr. Karthikeyan K, and Mr. Sasikumar M., participated in the training held at EDII, Periyakulam. The program focused on sustainable agriculture practices and entrepreneurship development. All members have successfully completed the training and received certificates.",
    "issueDate": "2025-07-11",
    "certificateType": "Certificate of Entrepreneurship Development",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-NGO-4-EVENT",
    "volunteerName": "Mr. Raffi A., Mr. Munver Sheriff A., Mr. Thamarai Selvam T, and Mr. Srinivasan K",
    "eventName": "ADF-NGO-Event – Fruit Ice Cream Training successfully completed. Our team, consisting of Mr. Raffi A., Mr. Munver Sheriff A., Mr. Thamarai Selvam T, and Mr. Srinivasan K., participated in the training held at EDII, Periyakulam. The program focused on sustainable Small Scale Development practices and entrepreneurship development. All members have successfully completed the training.",
    "issueDate": "2025-07-26",
    "certificateType": "Certificate of Entrepreneurship Development",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-NGO-5-EVENT",
    "volunteerName": "Mr. Raffi A., Mr. Munver Sheriff A., Mr. Thamarai Selvam T, and Mr. Srinivasan K",
    "eventName": "ADF-NGO-Event – Microgreens Production Training successfully completed. Our team, consisting of Mr. Raffi A., Mr. Munver Sheriff A., Mr. Thamarai Selvam T, and Mr. Srinivasan K., participated in the training held at EDII, Periyakulam. The program focused on sustainable Small Scale Development practices and entrepreneurship development. All members have successfully completed the training.",
    "issueDate": "2025-07-31",
    "certificateType": "Certificate of Entrepreneurship Development",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-TTA-001",
    "volunteerName": "Miss.Afrin Be K",
    "eventName": "Skill Course: Technical Tools Analysis. She completed the training and received certificates.",
    "issueDate": "2025-06-20",
    "certificateType": "Certificate of Technical Chart Tools Learning",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-TTA-002",
    "volunteerName": "Mr.Dinesh Kumar S",
    "eventName": "Skill Course: Technical Tools Analysis. He completed the training and received certificates.",
    "issueDate": "2025-06-20",
    "certificateType": "Certificate of Technical Chart Tools Learning",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-TTA-003",
    "volunteerName": "Mr.Praveenkumar S",
    "eventName": "Skill Course: Technical Tools Analysis. He completed the training and received certificates.",
    "issueDate": "2025-06-20",
    "certificateType": "Certificate of Technical Chart Tools Learning",
    "status": "Valid"
  },
  {
    "certificateId": "ADF-TTA-004",
    "volunteerName": "Mr.Ponraj",
    "eventName": "Skill Course: Technical Tools Analysis. He completed the training and received certificates.",
    "issueDate": "2025-06-20",
    "certificateType": "Certificate of Technical Chart Tools Learning",
    "status": "Valid"
  }
];

const Verification: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResult, setSearchResult] = useState<Certificate | null>(null);
  const [hasSearched, setHasSearched] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleSearch = () => {
    const certificate = certificatesData.find(
      cert => cert.certificateId.toLowerCase() === searchQuery.toLowerCase()
    );
    setSearchResult(certificate);
    setHasSearched(true);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold mb-8 text-center">
            Certificate || Event Verification
          </h1>

          <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark border border-border mb-8">
            <div className="flex gap-4">
              <div className="flex-1 relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground w-5 h-5" />
                <input
                  type="text"
                  placeholder="Enter Certificate ID (e.g., ADF-NGO-MEMBER000 or ADF-NGO-EVENT000)"
                  className="w-full pl-10 pr-4 py-2 rounded-md border border-input bg-background focus:outline-none focus:ring-2 focus:ring-primary"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
              </div>
              <button
                onClick={handleSearch}
                className="px-6 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
              >
                Verify
              </button>
              
              {/* Tooltip Button */}
              <div className="relative">
                <button
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => setShowTooltip(!showTooltip)}
                  className="p-2 rounded-full bg-primary/10 hover:bg-primary/20 transition-colors focus:outline-none focus:ring-2 focus:ring-primary"
                  aria-label="Information about verification"
                >
                  <Info className="w-5 h-5 text-primary" />
                </button>
                
                {/* Tooltip Content */}
                {showTooltip && (
                  <div className="absolute right-0 top-full mt-2 w-80 bg-card border border-border rounded-lg shadow-lg p-4 z-10 animate-fade-in">
                    <div className="text-sm space-y-3">
                      <h4 className="font-semibold text-foreground mb-2">How to Use Verification</h4>
                      
                      <p className="text-muted-foreground">
                        Enter a valid Arrow Drop Foundation ID to verify membership, volunteer status, or event authenticity.
                      </p>
                      
                      <div className="space-y-2">
                        <p className="font-medium text-foreground">Examples:</p>
                        <ul className="text-muted-foreground space-y-1 text-xs">
                          <li>• <code className="bg-muted px-1 rounded">ADF-NGO-2-EVENT</code></li>
                          <li>• <code className="bg-muted px-1 rounded">ADF-NGO-RAFFI</code></li>
                          <li>• <code className="bg-muted px-1 rounded">ADF-NGO-000753610</code></li>
                        </ul>
                      </div>
                      
                      <p className="text-muted-foreground">
                        Every volunteer/member/event photo is issued a unique ID by Arrow Drop Foundation. 
                        You can ask the respective person for their ID and check here.
                      </p>
                      
                      <div className="pt-2 border-t border-border">
                        <p className="text-xs text-primary font-medium">
                          We are committed to transparency and social service.
                        </p>
                      </div>
                    </div>
                    
                    {/* Tooltip Arrow */}
                    <div className="absolute -top-2 right-4 w-4 h-4 bg-card border-l border-t border-border transform rotate-45"></div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {hasSearched && (
            <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark border border-border animated-section">
              {searchResult ? (
                <div className="space-y-6">
                  <div className="flex items-center justify-between">
                    <h2 className="text-2xl font-semibold">Certificate Details</h2>
                    <div className="flex items-center gap-2">
                      {searchResult.status === "Valid" ? (
                        <div className="flex items-center gap-2 text-success">
                          <CheckCircle className="w-5 h-5" />
                          <span>Valid Certificate</span>
                        </div>
                      ) : (
                        <div className="flex items-center gap-2 text-error">
                          <XCircle className="w-5 h-5" />
                          <span>Expired - No Activities</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="grid gap-4">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-sm text-muted-foreground">Certificate ID</p>
                        <p className="font-medium">{searchResult.certificateId}</p>
                      </div>
                      <div>
                        <p className="text-sm text-muted-foreground">Volunteer Name</p>
                        <p className="font-medium">{searchResult.volunteerName}</p>
                      </div>
                    </div>
                    <div>
                      <p className="text-sm text-muted-foreground">Event Name</p>
                      <p className="font-medium">{searchResult.eventName}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-sm text-muted-foreground">Issue Date</p>
                        <p className="font-medium">{searchResult.issueDate}</p>
                      </div>
                      <div>
                        <p className="text-sm text-muted-foreground">Certificate Type</p>
                        <p className="font-medium">{searchResult.certificateType}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center py-8">
                  <XCircle className="w-12 h-12 text-error mx-auto mb-4" />
                  <h3 className="text-xl font-semibold mb-2">Invalid Certificate</h3>
                  <p className="text-muted-foreground">
                    This is not a valid certificate. Please contact our team for assistance.
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Verification;